var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "i-category-select" },
    [
      _c(
        "i-select",
        {
          attrs: {
            "icon-behavior": "focus",
            value: _vm.selectedCategory,
            options: _vm.categoryOptions,
            "fallback-value": _vm.fallbackValue,
            "clean-on-foucus": true,
            "enable-filter": false,
          },
          on: {
            select: _vm.onSubmit,
            submit: _vm.onSubmit,
            input: _vm.onInput,
          },
        },
        [
          _c("i", {
            staticClass: "isif isif-arrow-down",
            attrs: { slot: "icon" },
            slot: "icon",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }